import React, { useState, useEffect, useMemo } from "react";
import { MDBDataTable } from "mdbreact";
import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { fetchAllPages } from "../../common/tableData";
import { useNavigate, useParams } from "react-router-dom";
import Dummy from "../../assets/images/No_Image_Available.jpg";
import { withTranslation } from "react-i18next";

const SubCategories = withTranslation()(({ t }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getSubCategoriesData = async () => {
    setIsLoading(true);
    try {
      const subCategories = await fetchAllPages(
        (page, pageSize) =>
          `category/categories/?page=${page}&page_size=${pageSize}&parent_id=${id}`
      );
      setRows(subCategories);
    } catch (error) {
      console.error("Error fetching subcategory data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getSubCategoriesData();
  }, [id]);

  const handleEdit = (rowId) => {
    navigate(`/category/edit-sub-category/${rowId}`);
  };

  const handleExercises = (rowId) => {
    navigate(`/category/exercise/${id}/${rowId}`);
  };

  const tableData = useMemo(
    () => ({
      columns: [
        {
          label: t("Select"),
          field: "select",
          sort: "disabled",
          searchable: false,
          width: 50,
        },
        {
          label: t("ID"),
          field: "id",
          sort: "asc",
          width: 100,
        },
        {
          label: t("Image"),
          field: "image",
          sort: "disabled",
          searchable: false,
          width: 100,
        },
        {
          label: t("Name"),
          field: "name",
          sort: "asc",
          width: 150,
        },
        {
          label: t("Status"),
          field: "is_active",
          sort: "asc",
          width: 270,
        },
        {
          label: t("Subcategory"),
          field: "subCategory",
          sort: "disabled",
          searchable: false,
          width: 100,
        },
        {
          label: t("Action"),
          field: "edit",
          sort: "disabled",
          searchable: false,
          width: 100,
        },
      ],
      rows: rows.map((row) => ({
        ...row,
        select: <input type="checkbox" />,
        image: <img src={row.image || Dummy} alt="Body Part" width="50" height="50" />,
        edit: <Button color="primary" onClick={() => handleEdit(row.id)}>{t("Edit")}</Button>,
        subCategory: <Button color="primary" onClick={() => handleExercises(row.id)}>{t("Check Exercises")}</Button>,
        is_active: row.is_active ? t("True") : t("False"),
      })),
    }),
    [rows, t]
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle={t("Home")} title={t("Pain Area's")} titleLink="/category" breadcrumbItem={t("Pain Area Body Parts")} />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <CardTitle className="h4">{t("Pain Area Body Parts")}</CardTitle>
                    <Button color="primary" onClick={() => { navigate(`/category/create-sub-category/${id}`); }}>
                      <i className="typcn typcn-plus"></i> {t("Add New Body Part")}
                    </Button>
                  </div>

                  <MDBDataTable
                    responsive
                    striped
                    bordered
                    paging
                    searching
                    sortable
                    order={["id", "asc"]}
                    entries={10}
                    entriesOptions={[10, 25, 50, 100]}
                    displayEntries
                    info
                    infoLabel={[t("Showing"), t("to"), t("of"), t("entries")]}
                    paginationLabel={["<", ">"]}
                    searchLabel={t("Search")}
                    noRecordsFoundLabel={t(isLoading ? "Loading..." : "No records found")}
                    data={tableData}
                    className="custom-cursor-pointer"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
});

export default SubCategories;
